// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1N-Af","dragIcon":"Choice_dragIcon__2mD0R","left":"Choice_left__Fv3hf","input":"Choice_input__2MuA8"};